var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("จำนวนผู้สมัคร")]},proxy:true},{key:"body",fn:function(){return [_c('bar-chart',{attrs:{"chart-data":_vm.data,"options":_vm.options,"height":300}}),_c('br'),(_vm.checkData)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(" ไม่มีข้อมูล ")]):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }